import { TOKEN, TOKEN_ACCESS, TOKEN_EXPIRES_AT } from '@/constants/token';

export const isTokenValid = (): boolean => {
  const token = localStorage.getItem(TOKEN_ACCESS);
  if (!token) return false;

  const expiresAt = localStorage.getItem(TOKEN_EXPIRES_AT);
  if (!expiresAt) return false;

  const expiresAtMs = new Date(expiresAt).getTime();
  if (isNaN(expiresAtMs)) return false;

  return Date.now() < expiresAtMs;
};

export const clearAccessToken = () => {
  localStorage.removeItem(TOKEN_ACCESS);
  localStorage.removeItem(TOKEN_EXPIRES_AT);
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN);
  clearAccessToken();
};
